import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { motion } from 'motion/react';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

const animations = {
    expanded: {
        height: 'auto',
        opacity: 1,
        transition: {
            ease: [
                0.08,
                0.82,
                0.17,
                1
            ],
            duration: 0.3
        },
        overflow: 'hidden',
        display: 'block'
    },
    collapsed: {
        height: '0',
        opacity: 0,
        transition: {
            ease: [
                0.08,
                0.82,
                0.17,
                1
            ],
            duration: 0.3
        },
        overflow: 'hidden'
    }
};
const AccordionItem = ({ id , label , className , children , onClick , headingLevel ='h2' , expanded: expanded1 = false , variant ='normal' , fullWidth , icon , headerComponent ,  })=>{
    const [isExpanded, setIsExpanded] = React.useState(expanded1);
    const focusState = React.useState(false);
    /* Since we are not using 'hasFocus' (the first value in the tuple),
  we only need to use the second value, the mutator function 'setHasFocus' */ const setHasFocus = focusState[1];
    const handleClick = React.useCallback(()=>{
        setIsExpanded((expanded)=>{
            onClick && onClick(!expanded);
            return !expanded;
        });
    }, []);
    const handleFocus = React.useCallback(()=>setHasFocus(true)
    , []);
    const handleBlur = React.useCallback(()=>setHasFocus(false)
    , []);
    // Allow prop updates to override the local state
    React.useEffect(()=>{
        if (expanded1 !== isExpanded) {
            setIsExpanded(expanded1);
        }
    }, [
        expanded1
    ]);
    return /*#__PURE__*/ React.createElement("section", {
        "data-t": "accordion-item",
        className: classnames(className, 'accordion-item', {
            [`accordion-item--${variant}`]: variant
        })
    }, /*#__PURE__*/ React.createElement("button", {
        id: `${id}-control`,
        className: classnames('accordion-item__head', {
            [`${className}__head`]: className,
            'accordion-item__head--full-width': fullWidth,
            'accordion-item__head--with-icon': icon
        }),
        "aria-label": label,
        "aria-controls": id,
        "aria-expanded": isExpanded,
        onClick: handleClick,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, headerComponent && headerComponent, icon && /*#__PURE__*/ React.createElement(Icon, {
        name: icon,
        className: "accordion-item__icon",
        height: 32,
        width: 32
    }), label.length ? /*#__PURE__*/ React.createElement(Heading, {
        component: headingLevel,
        className: classnames('accordion-item__label', {
            [`${className}__label`]: className
        }),
        variant: "smallest"
    }, label) : null, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-down",
        className: classnames('accordion-item__chevron-icon', {
            [`${className}__chevron-icon`]: className
        }),
        height: 32,
        width: 32
    })), /*#__PURE__*/ React.createElement(motion.div, swcHelpers.extends({
        id: id,
        className: classnames('accordion-item__body', {
            [`${className}__body`]: className,
            'accordion-item__body--full-width': fullWidth
        }),
        "aria-labelledby": `${id}-control`,
        "aria-hidden": !isExpanded,
        initial: animations.collapsed,
        animate: isExpanded ? animations.expanded : animations.collapsed
    }, !isExpanded ? {
        inert: ''
    } : {}), children));
};

export { AccordionItem, AccordionItem as default };
//# sourceMappingURL=AccordionItem.js.map
